import React, { useState } from 'react';
import classNames from 'classnames';
import { Button } from 'vetrf-ui';
import { useUserDataContext } from 'components/UserDataContext/context';
import { getRoles } from 'utils/getRoles';
import { MenuItem } from './components/MenuItem/MenuItem';
import { filterSideBar } from './utils';
import { SideBarMenuItem } from './types';
import styles from './Sidebar.module.scss';

type SidebarProps = {
  onLinkClick: () => void;
};

export const Sidebar = ({ onLinkClick }: SidebarProps) => {
  const [isSidebarExpanded, setIsSidebarExpanded] = useState(
    localStorage.getItem('sidebarCollapsed') !== 'true'
  );
  const [activeSubmenuItem, setActiveSubmenuItem] = useState('');

  const hideSidebar = () => {
    setIsSidebarExpanded(false);
    localStorage.setItem('sidebarCollapsed', 'true');
  };

  const showSidebar = () => {
    setIsSidebarExpanded(true);
    localStorage.removeItem('sidebarCollapsed');
  };

  const { userData } = useUserDataContext();

  const items: SideBarMenuItem[] = filterSideBar(getRoles(userData));

  return (
    <div
      className={classNames(
        'sidebar',
        styles.sidebar,
        !isSidebarExpanded && 'min',
        !isSidebarExpanded && styles.min
      )}
    >
      <div className={styles.sidebarShortcuts}>
        {isSidebarExpanded ? (
          <div className={styles.sidebarShortcutsLarge}>
            <Button
              color="success"
              href="https://vetrf.ru/"
              icon=" vet vet-eagle"
              iconColor="white"
              iconSize={100}
              size="sm"
              tooltip="Официальный сайт Россельхознадзора"
            />
            <Button
              color="info"
              href="https://vetrf.ru/"
              icon=" vet vet-vetis"
              iconColor="white"
              iconSize={100}
              size="sm"
              tooltip="Ветис"
            />
            <Button
              color="warning"
              href="https://help.vetrf.ru/wiki/%D0%9A%D0%BE%D0%BC%D0%BF%D0%BE%D0%BD%D0%B5%D0%BD%D1%82_%D0%93%D0%B0%D0%BB%D0%B5%D0%BD"
              icon="users"
              iconColor="white"
              iconSize={100}
              size="sm"
              tooltip="Справка"
            />
          </div>
        ) : (
          <div className={styles.sidebarShortcutsMini}>
            <span className={`${styles.square} btn-success`} />
            <span className={`${styles.square} btn-info`} />
            <span className={`${styles.square} btn-warning`} />
            <span className={`${styles.square} btn-danger`} />
          </div>
        )}
      </div>
      <nav>
        <div>
          <ul className={styles.navList}>
            {items.map((item) => (
              <MenuItem
                key={item.icon}
                title={item.title}
                icon={item.icon}
                submenu={item.submenu}
                isLarge={isSidebarExpanded}
                setActiveSubmenuItem={setActiveSubmenuItem}
                activeSubmenuItem={activeSubmenuItem}
                onLinkClick={() => onLinkClick()}
              />
            ))}
          </ul>

          <div
            className={styles.sidebarToggle}
            onClick={isSidebarExpanded ? hideSidebar : showSidebar}
          >
            <i
              className={classNames(
                styles.toggleIcon,
                'ace-icon fa',
                isSidebarExpanded ? 'fa-angle-double-left' : 'fa-angle-double-right'
              )}
            />
          </div>
        </div>
      </nav>
    </div>
  );
};
